import { create } from "zustand";

export const InfraStore = create((set) => ({
  situacaoEstradasValue: null,
  manutencaoEstradasValue: null,

  infraMapImage: null,
  situacaoEstradasImage: null,
  manutencaoEstradasImage: null,
  infraImage: null,

  setSituacaoEstradasValue: (val) => set({ situacaoEstradasValue: val }),

  setManutencaoEstradasValue: (val) => set({ manutencaoEstradasValue: val }),

  setInfraMapImage: (img) => set({ infraMapImage: img }),

  setSituacaoEstradasImage: (img) => set({ situacaoEstradasImage: img }),

  setManutencaoEstradasImage: (img) => set({ manutencaoEstradasImage: img }),

  setInfraImage: (img) => set({infraImage: img}),

  reset: () =>
    set({
      situacaoEstradasValue: null,
      manutencaoEstradasValue: null,
    }),
}));
